import { useEffect, useCallback } from 'react'

export default function useInfiniteLoad(ref, loadFunction) {
  const infiniteLoad = useCallback(() => {
    const scrollPosition = window.scrollY + window.innerHeight + 40
    if (!ref.current) return
    if (scrollPosition >= ref.current.offsetTop + ref.current.clientHeight) {
      loadFunction()
    }
  }, [ref, loadFunction])

  useEffect(() => {
    window.addEventListener('scroll', infiniteLoad)
    return () => window.removeEventListener('scroll', infiniteLoad)
  }, [infiniteLoad])
}
